interface ShouldPruneEmptyGroupParams {
    // Business/entity selection does not count as a prune trigger.
    hasActiveFilter: boolean;
    childGroupRowCount: number;
    childAccountRowCount: number;
}

export const shouldPruneEmptyGroup = ({
    hasActiveFilter,
    childGroupRowCount,
    childAccountRowCount,
}: ShouldPruneEmptyGroupParams): boolean =>
    hasActiveFilter && childGroupRowCount === 0 && childAccountRowCount === 0;

export const resolveMergedAccountSortOrder = (sortOrders: number[]): number =>
    Math.min(...sortOrders);
